// import hooks
import { useTranslation } from 'react-i18next';
import useTableContext from 'components/admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';
import React, { useEffect, useState } from 'react';

// import components
import { Button } from '@mui/material';
import BackToListButton from './BackToListButton';
import InnerViewNavigator from './InnerViewNavigator';

// import styles
import {
  StyledToolbarContentBox,
  StyledToolbarMainBox
} from './ToolbarContent.styles';

// import types
import { ToolbarContentProps } from './ToolbarContent.types';

// import utils
import { createPortal } from 'react-dom';

const ToolbarContent: React.FC<ToolbarContentProps> = ({
  setIsInEditMode,
  isInEditMode,
  toggleInnerLayout,
  currentView,
  setCurrentView,
  views,
  navigatorLabelGetter,
  navigatorValueGetter
}) => {
  const { contentNodeForButtons } = useTableContext();
  const [loaded, setLoaded] = useState<boolean>(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (contentNodeForButtons?.current) setLoaded(true);
  }, [contentNodeForButtons?.current]);

  return loaded ? (
    createPortal(
      <StyledToolbarContentBox>
        <StyledToolbarMainBox>
          <InnerViewNavigator
            currentView={currentView}
            setCurrentView={setCurrentView}
            views={views}
            navigatorLabelGetter={navigatorLabelGetter}
            navigatorValueGetter={navigatorValueGetter}
          />
          <BackToListButton closeInnerView={toggleInnerLayout} />
        </StyledToolbarMainBox>
        {!isInEditMode && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsInEditMode(true)}
          >
            {t('edit')}
          </Button>
        )}
      </StyledToolbarContentBox>,
      contentNodeForButtons.current as HTMLDivElement
    )
  ) : (
    <></>
  );
};

export default ToolbarContent;
